<template>
	<div class="center text-center text-primary">
		<h3>Uh oh... something went wrong!</h3>
		<b-button variant="outline-primary" @click="$emit('logout')">Logout</b-button>
		<div><v-icon v-b-popover.hover="error" name="regular/question-circle" /></div>
	</div>
</template>

<script>
	export default {
		name: "Alert",
		props: {
			error: String
		},
		methods: {
			checkErrorStatus() {
				if (!this.error) {
					this.$router.replace('/home');
				}
			}
		},
        updated() {
			this.checkErrorStatus();
        },
		created() {
			this.checkErrorStatus();
		}
	}
</script>

<style scoped>
</style>